import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import ProductViewer from './components/ProductViewer';

// Function to initialize React in different environments
const initializeApp = () => {
  const rootElement = document.getElementById("root");

  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App rootDiv="root"/>);
  }
};

// Shopify initialization (if running inside Shopify)
window.initializeReactApp = (elementId) => {
  const container = document.getElementById(elementId);
  if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(<App rootDiv={elementId}/>);
  }
};

const App = ({rootDiv}) => {

  return (
      <ProductViewer 
        showAdditionalButtons={true}
        showDimensions={false}
        rootDiv={rootDiv}
      />
  );
};

// If running outside Shopify (e.g., localhost, WordPress), ensure React still mounts
if (!document.currentScript || !document.currentScript.dataset.shopify) {
  initializeApp();
}